var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconNav4(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    "aria-hidden": "true",
    role: "img",
    viewBox: "0 0 100 100",
    fill: "#70757D",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.54 14.45h5.12a.98.98 0 0 0 0-1.95h-5.12a.98.98 0 0 0 0 1.95z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.36 8.59H7.84a.98.98 0 0 0-.97.98V22.1c0 .54.43.97.97.97h16.52c.54 0 .98-.43.98-.97V9.57a.98.98 0 0 0-.98-.98zm-.98 12.53H8.82V10.54h14.56v10.58z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m31.16 4.57-2.95-2.95A.98.98 0 1 0 26.83 3l1.28 1.28H11.94a.98.98 0 0 0 0 1.95H28.1l-1.28 1.29A.98.98 0 0 0 28.2 8.9l2.95-2.95a.98.98 0 0 0 0-1.38zM18.48 25.4H3.93l1.28-1.28a.98.98 0 1 0-1.38-1.38L.88 25.69a.98.98 0 0 0 0 1.38l2.95 2.95a.97.97 0 0 0 1.38 0c.39-.38.39-1 0-1.38l-1.28-1.29h14.55a.98.98 0 1 0 0-1.95z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconNav4);
export default __webpack_public_path__ + "static/media/iconNav4.8f10e212e1e1341cf9cfe1ccdc9111fb.svg";
export { ForwardRef as ReactComponent };